import { useQuery } from '@tanstack/react-query'
import { notificationsApi } from '../api/notificationsApi'

export const useNotifications = (page: number) => {
  return useQuery({
    queryKey: ['notifications', page],
    queryFn: () => notificationsApi.getAll({ page, limit: 20 }),
  })
}
